
import React from 'react';
import { Button } from '@/components/ui/button';
import { LogOut } from 'lucide-react';
import { useLogout } from '@/hooks/useLogout';

interface LogoutButtonProps {
  variant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link";
  size?: "default" | "sm" | "lg" | "icon";
  className?: string;
}

const LogoutButton: React.FC<LogoutButtonProps> = ({ 
  variant = "outline", 
  size = "sm",
  className = "" 
}) => {
  const { logout, isLoggingOut } = useLogout();

  return (
    <Button 
      variant={variant} 
      size={size}
      onClick={logout}
      disabled={isLoggingOut}
      className={`${className} text-red-600 hover:bg-red-50 hover:text-red-700 border-red-200`}
    >
      <LogOut className="mr-2 h-4 w-4" />
      {isLoggingOut ? 'מתנתק...' : 'התנתקות'}
    </Button>
  );
};

export default LogoutButton;
